import React, { useContext, useEffect } from 'react';
import DwellDetailedViewTable from './DwellDetailedViewTable';
import { ViewDataContext } from '../../commons/context/view/ViewDataContext';
import { getDocumentURL } from '../../handler/ParentDataHandler';
import { DWELL_PACKAGE_STATUS, getPackageDrilDownRequestFilter, PACKAGE_STATUSES_PENDING_INDUCT } from '../../util/CommonUtils';
import { DwellFilterContext } from '../../commons/context/DwellFilterContext';
import { DWELL_FILTER_ACTIONS, FEATURES } from '../../commons/constants/CommonConstants';
import { chainWalk } from '../../commons/CommonUtils';
import { FeatureConfigContext } from '../../commons/context/FeatureConfigContext';

// This is used to fetch package list data for dwell detailed view and pass it to DwellDetailedViewTable component

export const DwellDetailedViewTableData = (props) => {

    const {viewModelFilter, filterDispatcher} = useContext(DwellFilterContext);
    const {configViewModel} = useContext(FeatureConfigContext);

    let search = window.location.search;
    let params = new URLSearchParams(search);
    let stationCode = params.get('stationCode');
    
    const {viewModel, dispatch} = useContext(ViewDataContext);
    const selectedTabForPackages = props.selectedTabForPackages;
    const addShipOptionForDwellDetail = chainWalk(() => configViewModel.featureStatus[FEATURES.IS_SHIP_OPTION_FILTER_FOR_DRILL_DOWN_API_ENABLED], false);

    let loadDefaultPackageList = () => {
        dispatch({ type: 'LOAD_VIEW', data:{filters: getPackageDrilDownRequestFilter(viewModel.metricResult, selectedTabForPackages, PACKAGE_STATUSES_PENDING_INDUCT, viewModel.stationTimeZone, addShipOptionForDwellDetail) , 
                        stationCode, view : "PACKAGE_DRILLDOWN" ,prevView : viewModel.prevView, leg : "FORWARD", dispatcher: dispatch, isCPTFilter: false, 
                        filterDispatcher: filterDispatcher
                    }})
        filterDispatcher({type: DWELL_FILTER_ACTIONS.SELECT_PACKAGE_STATUS_TILE, selectedPackageStatusListTile: PACKAGE_STATUSES_PENDING_INDUCT});
        filterDispatcher({type: DWELL_FILTER_ACTIONS.SELECT_TILE, selectedTile: [DWELL_PACKAGE_STATUS.INDUCT_PENDING]});
    }

    let removeFilterAndMetricAndPackageList = () => {
        dispatch({type: "RECEIVED_DATA", data: {
                    metricResult: [],
                    packageResultList: []
        }})
        filterDispatcher({type: DWELL_FILTER_ACTIONS.SELECT_PACKAGE_STATUS_TILE, selectedPackageStatusListTile: []});
        filterDispatcher({type: DWELL_FILTER_ACTIONS.SELECT_TILE, selectedTile: []});
    }

    // This code block is executed during first time of dwell detailed view after we fetch the package metrics from backend
    if (viewModelFilter.selectedPackageStatusListTile && 
        viewModelFilter.selectedPackageStatusListTile.length === 0 &&
        viewModel.metricResult && viewModel.metricResult.length >0) {
        loadDefaultPackageList();
    }
    
    
    useEffect(() => {
        getDocumentURL().then(result => {
                        dispatch({type: "SET_BASE_URL", data:result});
                    });
        if (viewModelFilter.selectedPackageStatusListTile && 
        viewModelFilter.selectedPackageStatusListTile.length > 0 &&
        viewModel.metricResult && viewModel.metricResult.length > 0) {
            removeFilterAndMetricAndPackageList();
        }

    }, [selectedTabForPackages]);


    return <DwellDetailedViewTable data = {viewModel.packageResultList} baseURL = {viewModel.baseURL} isLoading = {viewModel.isLoading}
        stationCode = {stationCode} dispatcher={dispatch} history={props.history} location={props.location} />;
};

export default DwellDetailedViewTableData;


// WEBPACK FOOTER //
// ./src/components/dwellRush/DwellDetailedViewTableData.js